import * as React from 'react'
import { LocationInput } from '$views/components/Forms/LocationInput'
import { broadcastFormDraftName, broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'

interface Props {
  errorText?: any
  updateAddressForExternalValidation?: (address) => void
}

export const Location: React.FC<Props> = ({ errorText, updateAddressForExternalValidation }) => {
  return (
    <>
      <LocationInput
        draftName={broadcastFormDraftName}
        draftPropertyName={broadcastFormSteps.serviceInformationStep.location}
        errorText={errorText}
        updateAddressForExternalValidation={updateAddressForExternalValidation}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/components/Location/Location.tsx